export default "__VITE_ASSET__DP5i50fp__"